import MobileHeader from '../__header/mobileHeader';

const $ = jQuery.noConflict();

function scrollFunc(e) {
	e.preventDefault();

	// Get CSS variable
	const stickySidebarTop =
		parseInt(
			getComputedStyle(document.documentElement).getPropertyValue(
				'--sticky-sidebar-top'
			),
			10
		) || 0;

	const headerBarHeight =
		parseInt(
			getComputedStyle(document.body).getPropertyValue(
				'--header-bar-height'
			),
			10
		) || 0;

	let stickyHeight = stickySidebarTop || headerBarHeight;

	const header = $('.main-header');
	const stickyClass = 'main-header--sticky';

	if (header.hasClass(stickyClass)) {
		stickyHeight += header.outerHeight();
	}

	// Only execute the following logic if screen width is 991px or less
	if ($(window).width() <= 991) {
		// Check if 'trip-grid__navigation-wrapper' exists on the page
		const tripGridWrapper = $('.trip-grid__navigation-wrapper');

		if (tripGridWrapper.length) {
			const heightWithActive = tripGridWrapper
				.addClass('active')
				.outerHeight();
			tripGridWrapper.removeClass('active');
			const heightWithoutActive = tripGridWrapper.outerHeight();

			// Calculate the difference in height
			const heightDifference = heightWithActive - heightWithoutActive;

			// If the 'active' class is currently on the 'trip-grid__navigation-wrapper', adjust the stickyHeight
			if (tripGridWrapper.hasClass('active')) {
				stickyHeight -= heightDifference;
			}
		}
	}

	const target = $($(this).attr('href'));

	if (
		$(this).attr('href') === '#next' &&
		$(this).parents('section').next().length > 0
	) {
		// Get offset after clicking
		const nextSectionOffset = $(this)
			.parents('section')
			.next()
			.offset().top;

		// Smooth Scroll to next section
		$('html, body').animate(
			{
				scrollTop: nextSectionOffset - stickyHeight,
			},
			600
		);

		MobileHeader.hideWrapper('.btn-hamburger', $('body'));
	} else if (target.length) {
		// Get offset after clicking
		const targetOffset = target.offset().top;

		$('html, body').animate(
			{
				scrollTop: targetOffset - stickyHeight,
			},
			600
		);

		MobileHeader.hideWrapper('.btn-hamburger', $('body'));
	}
}

function smoothScroll() {
	$('a[href^="#"]:not([href="#"])').on('click', scrollFunc);
}

export default smoothScroll;
